import _ from 'lodash'
import { MutationTree } from 'vuex';
import { WorkOvertimeApplication, WorkOvertimeApplicationsState } from '@/store/applications/workOvertime/types';

const mutations: MutationTree<WorkOvertimeApplicationsState> = {
  gotWorkOvertimeApplication: (
    state,
    workOvertime: WorkOvertimeApplication,
  ) => {
    state.applications = _.uniqBy([
      workOvertime,
      ...state.applications,
    ], 'applicationId')
  },
};

export default mutations
